
    <fieldmagic-text
      [content]="value | currency"
      [tooltip]="tooltip$ | async"
      [purpose]="purpose$ | async"
      [class.font-weight-bold]="isGroup$ | async"
      (click)="onClicked()"
    >
    </fieldmagic-text>
  